import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import Icons from "../svg/Icons.ts"
import ApiServer from "../ApiServer.js";
import { recipeSyncCache } from "./mealplannerApi.ts";
import * as amplify from "../util/amplify.ts";


async function recipeaskurl(){
  var url = await modal.askUrl({
    title:"mp.recipeadd.webtitle",
    image:Icons.recipe.recipe_web_import.toURL(),
    message:"mp.recipeadd.webtext",
    placeholder:"http://www.recipes.com/recipe",
    buttonName:"mp.recipeadd.save",
    validate:async function(url){
      try{
        var parsedUrl = new URL(url)
        return true;
      }catch(error){
        var message = (error instanceof Error)?error.message:String(error);
        modal.oops(message);
        return false;
      }
    }
  });
  if(url){
    recipeaddurl(url)
  }

}

export async function recipeaddurl(url){
  var 
    ogbean = await ApiServer.webog(url),
    recipe;
  if(ogbean.recipe){
    recipe = ogbean.recipe;
  }else{
    if(await modal.confirm("mp.addbyurlerror")){
      if(ogbean.isError){
        recipe = new ApiServer.types.RecipeInputBean({name:url,url});
      }else{
        recipe = new ApiServer.types.RecipeInputBean({name:ogbean.title,description:ogbean.description,url})
      }
    }
  }
  if(recipe){
    var result = await ApiServer.mprecipeput(recipe,ogbean.images.map(ogimage=>ogimage.url).slice(0,1));
    if(libLocation.getPageName()===INR.URL.MEALPLANNER){
      await recipeSyncCache.refresh()
      amplify.publish('recipeNeedRefresh')
      Html.trigger(null,'mpclick',[result.metaId])
      
    }else{
      recipeSyncCache.invalidate()
      libLocation.goTo(INR.URL.RECIPEBOX+'?id='+result.metaId)
      amplify.publish('recipeNeedRefresh')
    }
  }

}

export async function recipepickadd(name ?:string){
  var button = await modal.pick({
    title:"mp.recipeadd.title",
    gap:"var(--space-s)",
    button:[
      {title:"mp.recipeadd.webtitle",text:"mp.recipeadd.webtext",icon:Icons.recipe.recipe_web_import,onclick:recipeaskurl},
      {title:"mp.recipeadd.manualtitle",text:"mp.recipeadd.manualtext",icon:Icons.recipe.recipe_add_new_recipe_from_scratch,onclick:function(){
        libLocation.goTo(INR.URL.RECIPEBOX+'?mode=add&name='+(name?name:''))
      }}
    ]});
  if(button){
    button.onclick()
  }
  
}

Html.register({
  recipepickadd,
  
})